const routes = [
  {
    name: 'purchases',
    path: '/purchases',
    component() {
      return import('@/pages/purchase/Purchases.vue')
    },
  },
  {
    name: 'purchases/detail/confirm',
    path: '/purchases/:uuid/confirm',
    component() {
      return import('@/pages/purchase/PurchasesDetailConfirm.vue')
    },
  },
  {
    name: 'purchases/detail/complete',
    path: '/purchases/:uuid/complete',
    component() {
      return import('@/pages/purchase/PurchasesDetailComplete.vue')
    },
  },
]

export default routes
